import { styled } from "@mui/material/styles";
import { Container, Box, Button } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import backgroundImage from "../resources/fondo_login.png";
import logoImage from "../resources/logo.png";

export const BackgroundBox = styled(Box)({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundImage: `url(${backgroundImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  zIndex: -1,
});

export const LoginContainer = styled(Container)({
  width: "100vw",
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
});

export const LoginBox = styled(Box)({
  backgroundColor: "rgba(255, 255, 255, 1)",
  padding: "28px 26px",
  borderRadius: "18px",
  border: "1px solid rgba(255, 255, 255, 0.7)",
  boxShadow: "0 20px 50px rgba(5, 43, 73, 0.22)",
  textAlign: "center",
  maxWidth: "360px",
  width: "100%",
});

export const LogoBox = styled(Box)({
  backgroundImage: `url(${logoImage})`,
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  width: "100%",
  height: "120px",
});

export const StyledIcon = styled(AccountCircleIcon)({
  width: "72px",
  height: "72px",
  color: "#0b679e",
});

export const StyledButton = styled(Button)({
  width: "100%",
  padding: "10px 16px",
  fontSize: "15px",
  fontWeight: "bold",
  backgroundColor: "#0b6baa",
  color: "white",
  borderRadius: "9px",
  textTransform: "none",
  transition: "all 0.3s ease",

  "&:hover": {
    backgroundColor: "#084d7a",
    transform: "translateY(-1px)",
  },

  "&:active": {
    transform: "scale(0.98)",
    transition: "transform 0.1s ease",
  },
});
